import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { localizeHowtoUrl } from '@shared/utils/howto-url';

/**
 * Points a how-to site URL to the version in the current app language.
 * Impure so links follow language changes, the last result is cached to keep change detection cheap.
 */
@Pipe({
    standalone: true,
    name: 'howtoUrl',
    pure: false
})
export class HowtoUrlPipe implements PipeTransform {

    private lastUrl?: string;
    private lastLanguage?: string;
    private lastResult = '';

    constructor(private translate: TranslateService) {}

    transform(url: string): string {

        const language = this.translate.getCurrentLang();

        if (url !== this.lastUrl || language !== this.lastLanguage) {
            this.lastUrl = url;
            this.lastLanguage = language;
            this.lastResult = localizeHowtoUrl(url, language);
        }

        return this.lastResult;
    }
}
